import { createAction } from "redux-actions";

export const getLocations = createAction("GET_LOCATIONS");
export const getLocationsSuccess = createAction("GET_LOCATIONS_SUCCESS");
export const getLocationsError = createAction("GET_LOCATIONS_ERROR");
export const setLocationStatus = createAction("SET_LOCATION_STATUS");
export const setLocationsLoaded = createAction("SET_LOCATIONS_LOADED");
export const setLocationsLoading = createAction("SET_LOCATIONS_LOADING");
